import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { Menu } from '@admin/models/Menu.model';
import { FormComponent, MainCardComponent } from '@shared/components';
import { Profile } from '@admin/models/Profile.model';
import { SessionService } from '@services/session.service';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'app-home',
  imports: [MainCardComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent extends FormComponent {
  private router = inject(Router);
  private session = inject(SessionService);

  override data: Profile = new Profile();

  items: Menu[] = [
    {
      id: 2,
      title: '',
      route: '/admin/campaigns',
      actions: 'Campaigns',
      icon: 'fa-solid fa-folder',
    },
    {
      id: 3,
      title: 'New Client',
      route: '/admin/clients/create',
      actions: 'Add',
      icon: 'fa-solid fa-user-plus',
    },
    {
      id: 4,
      title: 'New Campaign',
      route: '/admin/campaigns/create',
      actions: 'Start',
      icon: 'fa-solid fa-folder-plus',
    },
  ];

  ngOnInit() {
    this.session.profile$.subscribe(() => {
      if (this.session.profile) {
        this.data = plainToClass(Profile, this.session.profile);
      }
    });
  }

  goTo(route?: string) {
    this.router.navigate([`${route}`]);
  }
}
